module.exports = __webpack_public_path__ + "static/media/unlimitedGamesPlayed_5000_10000.01d10020.png";